// extracted by mini-css-extract-plugin
module.exports = {"w1ebswux":"w1ebswux","fadeFromTransparent":"fadeFromTransparent"};